import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';


@Injectable({
	providedIn: 'root'
})

export class DropletService {

	portfolioContent  : any;
	blogDetailContent : any;
	teamDetailContent : any;

  	constructor(private http : HttpClient) { }

  	getBlogContent () {
  		return this.http.get('assets/data/blog.json').pipe(map(Response => Response));
  	}

  	getTeamContent () {
  		return this.http.get('assets/data/team.json').pipe(map(Response => Response));
  	}

  	getPortfolioContent () {
  		return this.http.get('assets/data/portfolio.json').pipe(map(Response => Response));
  	}

  	getServiceContent () {
  		return this.http.get('assets/data/services.json').pipe(map(Response => Response));
  	}

  	getProcessContent () {
  		return this.http.get('assets/data/process.json').pipe(map(Response => Response));
  	}

  	getClientContent () {
  		return this.http.get('assets/data/client-slider.json').pipe(map(Response => Response));
  	}

  	getSocialIconsContent () {
  		return this.http.get('assets/data/social-icons.json').pipe(map(Response => Response));
  	}

  	getCategoryContent () {
  		return this.http.get('assets/data/categories.json').pipe(map(Response => Response));
  	}

  	getTagContent () {
  		return this.http.get('assets/data/tags.json').pipe(map(Response => Response));
  	}

  	getRecentCommentsContent () {
  		return this.http.get('assets/data/recent-comments.json').pipe(map(Response => Response));
  	}

  	getAboutAuthorContent () {
  		return this.http.get('assets/data/about-author.json').pipe(map(Response => Response));
  	}

  	getHomeBannerContent () {
  		return this.http.get('assets/data/home-banner.json').pipe(map(Response => Response));
  	}

  	getFaqContent () {
  		return this.http.get('assets/data/faq.json').pipe(map(Response => Response));
  	}

  	getSearchContent () {
  		return this.http.get('assets/data/search.json').pipe(map(Response => Response));
  	}

  	getPricingContent () {
  		return this.http.get('assets/data/pricing.json').pipe(map(Response => Response));
  	}

  	getCounterContent() {
  		return this.http.get('assets/data/counter.json').pipe(map(Response => Response));
  	}

  	getTestimonialContent() {
  		return this.http.get('assets/data/testimonial.json').pipe(map(Response => Response));
  	}
}
